import { Col, Container, Row } from "react-bootstrap";
import HeroTextReveal from './HeroTextReveal';
import Styles from './style.module.css';
import { imageProps, heroSizes } from '../../imageAssets';

const mathSymbols = ['∑', 'π', '∫', '√', 'Δ', '∞', 'θ', 'λ'];

const particles = Array.from({ length: 10 });

export default function WebsiteCover() {
    const scrollToContent = () => {
        window.scrollTo({
            top: window.innerHeight * 0.85,
            behavior: 'smooth'
        });
    };

    return (
        <Col xs={12} className={Styles.heroSection} style={{ overflowX: 'clip' }}>
            {/* Aurora Background */}
            <article className={Styles.auroraBackground}>
                <article className={Styles.auroraOrb} />
                <article className={Styles.auroraOrb} />
                <article className={Styles.auroraOrb} />
            </article>

            {/* Floating Math Symbols */}
            <article className={Styles.mathSymbolsContainer} aria-hidden="true">
                {mathSymbols.map((symbol, idx) => (
                    <span key={idx} className={Styles.mathSymbol}>
                        {symbol}
                    </span>
                ))}
            </article>

            {/* Particles */}
            <article className={Styles.particlesContainer} aria-hidden="true">
                {particles.map((_, idx) => (
                    <span key={idx} className={Styles.particle} />
                ))}
            </article>

            {/* Hero Content */}
            <Container className={`position-relative ${Styles.heroContent}`}>
                {/* CoverAvatar Background — Left Side */}
                <div className={`${Styles.coverAvatarBg} ${Styles.heroPortraitReveal}`}>
                    <img {...imageProps('hero', heroSizes)} alt="" aria-hidden="true" className={Styles.coverAvatarImg} loading="eager" fetchpriority="high" />
                </div>

                <Row className="g-4 align-items-center justify-content-center flex-lg-row flex-column-reverse">
                    {/* Text Side */}
                    <Col lg={6} xs={12} className={Styles.heroTextCol}>
                        <HeroTextReveal delay={0.05}>
                            <h1 className="fw-bold mb-0">
                                <span className={Styles.smallText}>المهندس في الرياضيات</span>
                            </h1>
                        </HeroTextReveal>

                        <HeroTextReveal delay={0.12}>
                            <h3 className={Styles.redText}>
                                <span className={Styles.boldText}>أستاذ / </span>محمد يوسف
                            </h3>
                        </HeroTextReveal>

                        <HeroTextReveal delay={0.2}>
                            <p className={Styles.description}>
                                منصتك في علم الرياضيات .. <br /> بيتك ومطرحك
                            </p>
                        </HeroTextReveal>

                        {/* Scroll Indicator */}
                        <div className={Styles.scrollIndicator}
                            onClick={scrollToContent}
                            role="button" tabIndex={0} aria-label="اكتشف المزيد"
                            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scrollToContent(); } }}
                        >
                            <article className={Styles.scrollIndicatorMouse}>
                                <article className={Styles.scrollIndicatorWheel} />
                            </article>
                            <span className={Styles.scrollIndicatorText}>اكتشف المزيد</span>
                        </div>
                    </Col>

                    {/* Image Side */}
                    <Col lg={6} xs={12} className="d-flex justify-content-center align-items-center">
                        <div className={`w-100 d-flex justify-content-center align-items-center ${Styles.heroProfileReveal}`}>
                            <article className={Styles.imgStage}>
                                <article className={Styles.profileGlowRing} aria-hidden="true" />
                                <img {...imageProps('hero', heroSizes)} alt="أستاذ محمد يوسف" className={Styles.profileMainImg} loading="eager" fetchpriority="high" />
                            </article>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Col>
    );
}
